import { DateTime } from "luxon";

export const getPreviousWeekRange = () => {
  const now = DateTime.local().toUTC();
  const previousSunday = now.minus({ days: now.weekday % 7 + 7 }).toFormat('yyyy-MM-dd');
  const previousSaturday = now.minus({ days: now.weekday % 7 + 1 }).toFormat('yyyy-MM-dd');
  return { previousSunday, previousSaturday };
};